var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "boek" },
    [
      _vm.loading
        ? _c("div", { staticClass: "loading" }, [
            _vm._v("Een moment geduld..."),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("Agenda", {
        attrs: {
          session: _vm.sessie,
          ajax: _vm.ajax,
          handleSelect: _vm.handleSelect,
        },
      }),
      _vm._v(" "),
      _vm.date !== ""
        ? _c(
            "div",
            [
              _c("hr"),
              _vm._v(" "),
              _c("Time", {
                attrs: {
                  session: _vm.sessie,
                  ajax: _vm.ajax,
                  date: _vm.date,
                  value: _vm.time,
                },
                on: { input: (e) => (_vm.time = e) },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.date !== "" && _vm.time !== ""
        ? _c("div", [
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "session-details-date" }, [
              _c("div", { staticClass: "session-details-date-date" }, [
                _c("i", {
                  staticClass: "fa fa-calendar fa-fw text-primary mr-1",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v("\n          " + _vm._s(_vm.date) + "\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "session-details-date-time" }, [
                _c("i", {
                  staticClass: "fa fa-clock-o fa-fw text-primary mr-1",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.time.value.start) +
                    " - " +
                    _vm._s(_vm.time.value.end) +
                    "\n        "
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.date !== "" && _vm.time !== ""
        ? _c("div", [
            _c("hr"),
            _vm._v(" "),
            _c("form", { ref: "form", attrs: { action: "", method: "post" } }, [
              _c("input", {
                ref: "product",
                attrs: { name: "add-to-cart", type: "hidden", value: "" },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  name: "quantity",
                  type: "hidden",
                  value: "1",
                  min: "1",
                },
              }),
              _vm._v(" "),
              _c("input", {
                ref: "button",
                staticClass: "d-none",
                attrs: {
                  name: "submit",
                  type: "submit",
                  value: "Boek deze tafelsessie",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn",
                  staticStyle: { width: "100%" },
                  on: { click: _vm.handleClick },
                },
                [_vm._v("Boek deze tafelsessie")]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Boek.vue